import React from "react";
import { Document, Page, Text, View, StyleSheet, Font } from "@react-pdf/renderer";

import moment from "moment";

moment.locale();

Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Oswald",
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: "Oswald",
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 10,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
    fontWeight: 700,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  tableBody: {
    fontSize: 8,
    textAlign: "center",
  },
  tableHeader: {
    textAlign: "center",
  },
  
  table: {
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    borderTop: "1px solid #EEE",
    paddingTop: 8,
    paddingBottom: 8,
  },
  headerTable: {
    borderTop: "none",
  },
  bold: {
    fontWeight: "bold",
  },
  
  row0: {
    width: "10%",
  },
  row1: {
    width: "20%",
  },
  row2: {
    width: "20%",
  },
  row3: {
    width: "15%",
  },
  row4: {
    width: "10%",
  },
});

const ExportToPdfCatalogSectionsDesign = ({ data }) => {

  return (
    <Document>
      <Page style={styles.body} size="A4" orientation="landscape">
        <Text style={styles.title} fixed>
          {" "}
          ~ Table Users ~{" "}
        </Text>
        <Text style={styles.author} fixed>
          {" "}
          {moment().format("lll")}
        </Text>

        <View style={[styles.row, styles.bold, styles.headerTable, styles.header, styles.tableHeader]} fixed>
          <Text style={styles.row0}>Nro</Text>
          <Text style={styles.row1}>Name</Text>
          <Text style={styles.row2}>Description</Text>
          <Text style={styles.row3}>Abbreviation</Text>
          <Text style={styles.row4}>Status</Text>
        </View>

        {data.map((row, i) => (
          <View key={i} style={[styles.row, styles.tableBody]} wrap={false}>
            <Text style={styles.row0}>{i + 1}</Text>
            <Text style={styles.row1}>{row.name}</Text>
            <Text style={styles.row2}>{row.description}</Text>
            <Text style={styles.row3}>{row.abbreviation}</Text>
            <Text style={styles.row4}>{row.deleted === false ? "Act" : "Ina"}</Text>
          </View>
        ))}

        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} fixed />
      </Page>
    </Document>
  );
};

export default ExportToPdfCatalogSectionsDesign;
